import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <div className="min-vh-100">
        {/* Header Section */}
        <div className=" py-5">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                <h1 className="display-6 fw-bold mb-3">Privacy Policy</h1>
                <p className="text-secondary mb-0">
                  <strong>Effective Date:</strong> August 14, 2026 &nbsp;|&nbsp;{" "}
                  <strong>Official Website:</strong> CaptureEdits.com
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="p-4 mb-4">
                <div
                  className="p-3 mb-5 bg-light border-start border-4 rounded"
                  style={{ borderColor: "#008080" }}
                >
                  <p className="mb-0">
                    At <strong>Capture Edits</strong>, we are committed to
                    protecting your personal data and respecting your
                    privacy. This Privacy Policy explains how we collect,
                    use, store, and safeguard your information when you
                    visit our website, place orders, or use our photo and
                    video editing services.
                  </p>
                </div>

                {/* 1. Information We Collect */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    1. INFORMATION WE COLLECT
                  </h2>
                  <p className="mb-3">
                    We collect information to provide, maintain, and improve
                    our professional editing services.
                  </p>

                  <h4 className="h5 fw-bold mb-3">
                    A. Information You Provide to Us:
                  </h4>
                  <ul className="mb-3">
                    <li>
                      <strong>Account &amp; Contact Data:</strong> Name,
                      email address, phone number, physical address, and
                      communication records.
                    </li>
                    <li>
                      <strong>Order &amp; Content Data:</strong> Digital
                      assets (photos, images, video files) that you upload
                      for editing, order specifications, and client
                      instructions.
                    </li>
                    <li>
                      <strong>Billing Details:</strong> Invoice information
                      and transaction details (processed securely via
                      authorized third-party gateways like PayPal).
                    </li>
                  </ul>

                  <h4 className="h5 fw-bold mb-3">
                    B. Automatically Collected Information:
                  </h4>
                  <ul className="mb-3">
                    <li>
                      <strong>Server Log Data:</strong> IP address, browser
                      type and version, device characteristics, operating
                      system, referring URL, date/time stamps, and pages
                      visited.
                    </li>
                    <li>
                      <strong>Cookies &amp; Tracking:</strong> Small data
                      files stored on your device to maintain session
                      states, remember preferences, and ensure seamless
                      navigation.
                    </li>
                  </ul>
                </section>

                {/* 2. How We Use Your Information */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    2. HOW WE USE YOUR INFORMATION
                  </h2>
                  <p className="mb-3">
                    We use your data strictly for the following legitimate
                    purposes:
                  </p>
                  <ul className="mb-3">
                    <li>
                      <strong>Fulfilling Orders:</strong> Processing,
                      editing, delivering, and archiving your image and
                      video files.
                    </li>
                    <li>
                      <strong>Customer Support &amp; Communication:</strong>{" "}
                      Responding to inquiries, sending order updates,
                      delivery links, and invoices.
                    </li>
                    <li>
                      <strong>Website Functionality:</strong> Optimizing
                      display performance, securing systems against
                      fraud/unauthorized access, and system diagnostics.
                    </li>
                    <li>
                      <strong>Legal &amp; Contractual Compliance:</strong>{" "}
                      Complying with applicable legal obligations and
                      enforcing our service terms.
                    </li>
                  </ul>
                </section>

                {/* 3. Legal Basis for Processing */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    3. LEGAL BASIS FOR PROCESSING (GDPR COMPLIANCE)
                  </h2>
                  <p className="mb-3">
                    Under the General Data Protection Regulation (GDPR), we
                    process your data based on:
                  </p>
                  <ul className="mb-4">
                    <li>
                      <strong>Performance of a Contract (Art. 6(1)(b)
                      GDPR):</strong> To fulfill editing orders, deliver
                      finished files, and process billing.
                    </li>
                    <li>
                      <strong>Legitimate Interests (Art. 6(1)(f) GDPR):</strong>{" "}
                      To operate, optimize, and secure our website, and to
                      answer direct customer inquiries.
                    </li>
                    <li>
                      <strong>Consent (Art. 6(1)(a) GDPR):</strong> Where you
                      have explicitly agreed (e.g., subscribing to optional
                      marketing updates).
                    </li>
                  </ul>
                  <div
                    className="p-3 bg-light border-start border-4 rounded"
                    style={{ borderColor: "#008080" }}
                  >
                    <p className="mb-0">
                      <strong>Data Processor Role:</strong> For the
                      photos/media submitted by photographers or clients,
                      Capture Edits acts strictly as a{" "}
                      <strong>Data Processor</strong> (contractor)
                      processing images on behalf of the customer (the Data
                      Controller).
                    </p>
                  </div>
                </section>

                {/* 4. Data Retention & Security */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    4. DATA RETENTION &amp; SECURITY
                  </h2>
                  <ul className="mb-3">
                    <li>
                      <strong>File Storage Policy:</strong> Finished files
                      are available for download in your user profile or
                      link for <strong>25 days</strong>. Internal backup
                      copies are stored securely on our systems for up to{" "}
                      <strong>45 days</strong> post-delivery for redundancy,
                      after which they are permanently deleted.
                    </li>
                    <li>
                      <strong>Confidentiality:</strong> The media you upload
                      and the final outputs are strictly private and will{" "}
                      <strong>never</strong> be shared, published, or made
                      public without your explicit prior written consent.
                    </li>
                    <li>
                      <strong>Security Measures:</strong> We implement
                      industry-standard technical and organizational
                      security measures (including SSL/HTTPS encryption) to
                      protect against unauthorized access, loss, or
                      alteration.
                    </li>
                  </ul>
                </section>

                {/* 5. Third-Party Services & Data Transfers */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    5. THIRD-PARTY SERVICES &amp; DATA TRANSFERS
                  </h2>
                  <p className="mb-3">
                    We use trusted third-party providers for file handling,
                    cloud storage, and payments:
                  </p>
                  <ul className="mb-3">
                    <li>
                      <strong>
                        Cloud File Transfers (Dropbox / Google Drive /
                        OneDrive / WeTransfer):
                      </strong>{" "}
                      Used for receiving and sharing large media files. File
                      handling is governed by data processing agreements
                      ensuring compliance with international transfer
                      standards (such as Standard Contractual Clauses (SCCs)
                      or the EU-U.S. Data Privacy Framework).
                    </li>
                    <li>
                      <strong>Payment Gateways (PayPal):</strong> Payments
                      are processed via PayPal (Europe) S.à r.l. et Cie,
                      S.C.A. We receive transaction confirmations and IDs;
                      sensitive payment card details remain securely
                      encrypted with PayPal.
                    </li>
                  </ul>
                </section>

                {/* 6. Your Privacy Rights */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    6. YOUR PRIVACY RIGHTS
                  </h2>
                  <p className="mb-3">
                    Under GDPR and international privacy regulations, you
                    have the right to:
                  </p>
                  <ul className="mb-3">
                    <li>
                      <strong>Access:</strong> Request a copy of the
                      personal data we hold about you.
                    </li>
                    <li>
                      <strong>Rectification:</strong> Request correction of
                      inaccurate or incomplete information.
                    </li>
                    <li>
                      <strong>Erasure ("Right to be Forgotten"):</strong>{" "}
                      Request deletion of your personal data when no longer
                      required.
                    </li>
                    <li>
                      <strong>Object to Processing:</strong> Object at any
                      time to the processing of your data based on
                      legitimate interest.
                    </li>
                    <li>
                      <strong>Withdraw Consent:</strong> Revoke any consent
                      previously given at any time.
                    </li>
                  </ul>
                </section>

                {/* 7. Cookie Policy */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    7. COOKIE POLICY
                  </h2>
                  <p className="mb-3">
                    Our website uses essential session cookies to enable
                    core ordering features and navigation. You can modify
                    your browser settings to reject or delete cookies at any
                    time, though some functional features of the site may
                    be limited as a result.
                  </p>
                </section>

                {/* 8. Updates to this Policy */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">
                    8. UPDATES TO THIS POLICY
                  </h2>
                  <p className="mb-3">
                    We may update this Privacy Policy periodically to
                    reflect changes in legal requirements or operational
                    practices. The updated version will always be posted on
                    this page with a revised effective date.
                  </p>
                </section>

                {/* 9. Contact Us */}
                <section className="mb-5">
                  <h2 className="h3 text_maincolor mb-4">9. CONTACT US</h2>
                  <p className="mb-3">
                    If you have questions, feedback, or wish to exercise
                    your data privacy rights, please contact us:
                  </p>
                  <div className="p-3 bg-light rounded">
                    <p className="mb-1">
                      <strong>Brand / Business:</strong> Capture Edits
                    </p>
                    <p className="mb-1">
                      <strong>Official Website:</strong>{" "}
                      <a
                        href="https://captureedits.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        CaptureEdits.com
                      </a>
                    </p>
                    <p className="mb-0">
                      <strong>Email Address:</strong>{" "}
                      <a href="mailto:info@captureedits.com">
                        info@captureedits.com
                      </a>
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
